import { createApp } from 'vue';
import cmpBlogCategoryPaginator from '../vue/blog/BlogCategoryPaginator.vue';

window.Blog = (function() {
	const initCategoryPaginators = (root = document) => {
		const sections = root.querySelectorAll('.blog-category-section');
		return Array.from(sections).map((section) => {
			const mountElement = section.querySelector('.blog-category-paginator-mount');
			if (mountElement == null || mountElement.dataset.blogPaginatorMounted === 'true') return null;
			const component = createApp(cmpBlogCategoryPaginator, {
				fetchUrlBase: section.dataset.fetchUrlBase ?? '',
				targetId: section.dataset.targetId ?? '',
				initialPageIndex: Number(section.dataset.pageIndex ?? 0),
				pageSize: Number(section.dataset.pageSize ?? 1),
				nrRecords: Number(section.dataset.nrRecords ?? 0)
			});
			const instance = component.mount(mountElement);
			mountElement.dataset.blogPaginatorMounted = 'true';
			return instance;
		}).filter(x => x != null);
	};

	const initCategoryLoading = () => {
		const link = document.getElementById('blog-load-more-categories');
		const container = document.getElementById('blog-overview-categories');
		const status = document.getElementById('blog-category-load-status');
		if (link == null || container == null || status == null) return;
		let pending = false;
		link.addEventListener('click', async (event) => {
			// Preserve normal navigation when explicitly opening another tab.
			if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
			event.preventDefault();
			if (pending) return;
			pending = true;
			link.setAttribute('aria-disabled', 'true');
			link.textContent = 'Loading categories...';
			status.textContent = '';
			try {
				const url = new URL(link.href, window.location.href);
				url.searchParams.set('sections', 'true');
				const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
				if (!response.ok) throw new Error('Could not load categories.');
				const html = new DOMParser().parseFromString(await response.text(), 'text/html');
				const batch = html.querySelector('.blog-overview-batch');
				if (batch == null) throw new Error('Missing category response.');
				const added = Array.from(batch.querySelectorAll('.blog-category-section'));
				const existing = new Set(Array.from(container.querySelectorAll('.blog-category-section')).map(section => section.dataset.categoryId));
				let count = 0;
				for (const section of added) {
					if (existing.has(section.dataset.categoryId)) continue;
					container.appendChild(section);
					existing.add(section.dataset.categoryId);
					count++;
				}
				initCategoryPaginators(container);
				const nextUrl = batch.dataset.nextUrl ?? '';
				if (nextUrl.length > 0) link.href = nextUrl;
				else link.hidden = true;
				status.textContent = nextUrl.length > 0 ? `${count} more categories loaded.` : 'All categories loaded.';
			} catch {
				status.textContent = 'Could not load more categories right now. Please try again.';
			} finally {
				pending = false;
				link.removeAttribute('aria-disabled');
				link.textContent = 'Load more categories';
			}
		});
	};

	const initCategoryChooser = () => {
		const filter = document.getElementById('blog-category-filter');
		if (filter == null) return;
		filter.hidden = false;
		filter.addEventListener('input', () => {
			const term = filter.value.trim().toLocaleLowerCase();
			for (const item of document.querySelectorAll('.blog-category-chooser li')) {
				item.hidden = !item.textContent.toLocaleLowerCase().includes(term);
			}
		});
	};

	document.addEventListener('DOMContentLoaded', () => {
		initCategoryPaginators();
		initCategoryLoading();
		initCategoryChooser();
	});
	return { initCategoryPaginators };
})();
